<template>
  <router-layout>
    <div class="Lbigbox">
      <div class="headbox">
        <van-search v-model="value" :left-icon="icons" placeholder="输入文章标题进行检索" show-action shape="round" @search="cs(value)">
          <template #action>
            <div @click="cs(value)">搜索</div>
          </template>
        </van-search>
      </div>
      <div class="swipe">
        <van-swipe v-if="docType == 25" class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item v-for="(item, index) in records" :key="index">
            <img :src="item.picUrl" alt="" class="img" @click="lbtz(item.linkUrl, item.linkType,item,index)" v-track:exposure:content|click:content :track-params="item.bp"/>
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="k8"></div>
      <div class="bodybox">
        <van-list v-model="loading" :finished="finished" :offset="10" :finished-text="textgd" @load="onLoad">
          <div v-for="(item, index) in collect" :key="'f' + index" @click="tz(item.uuid, item.docType, item)">
            <Collect :collect="item" :SeoLink="changeSeo(item.uuid, item.docType, item)"></Collect>
            <van-divider class="hrk" />
          </div>
        </van-list>
      </div>
      <div class="kong"></div>
      <div class="sho" v-if="sh == 1">
        <div class="sho1">未搜索到相关内容</div>
        <div class="sho2">没有你想要的结果，换个词试试</div>
      </div>
    </div>
  </router-layout>
</template>

<script>
import Collect from '../compnents/Collect.vue'
import { urlShare } from '@/assets/js/utils'
import { maidianP } from '../assets/js/maidian'
export default {
  name: 'Letters',
  components: {
    Collect
  },
  data() {
    return {
      news: {},
      Ldata: [],
      value: '',
      records: [],
      collect: [],
      docType: this.$route.params.docType,
      loading: false,
      finished: false,
      refreshing: false,
      length: 0,
      page: 1,
      show: false,
      is_hz: true,
      documentPage: 1,
      nub: 0,
      pa: 1,
      sh: 0,
      textgd: '',
      icons: this.$store.state.app.qiniuHostUrl + 'searce.png',
      dieaseId: '',
      bosUserIds: '',
      relatedDocId: '',
      DocId: this.$router.currentRoute.query.DocId,
      zt: '',
      totalPage: 0,
      share: {},
      fromfullname: '',
      pre_page_name: '',
    }
  },
  // created() {
  //   console.log(this.$route.params.docType)
  // },
  // beforeRouteEnter(to, from, next) {
  //   console.log(from.path)
  //   if(from.path == '/Letter/25' || from.path == '/Letter/1') {
  //     next('/')
  //   }else {
  //     next()
  //   }
  //   // next()
  // },
  beforeRouteUpdate(to, from, next) {
    if(to.fullPath!=from.fullPath) {
      this.docType = parseInt(to.params.docType)
      this.documentList()
      next()
    }
  },
   beforeRouteEnter(to, from, next) {
    // console.log(from.path);
    next((vm) => {
      vm.fromfullname = from.fullPath
      vm.pre_page_name = from.meta.title
    })
  },
  methods: {
    maidian(event,value){
       this.$api.aliyunHzMD({
				...maidianP(event),
				funname: this.$route.fullPath,
        fromfullname: this.fromfullname
			})
      this.$api.aliyunHzMD({
        ...maidianP('rare_ContentClick'),
        fromfullname: this.fromfullname,
        funname: this.$route.fullPath,
        pre_page_name: this.pre_page_name,
        block_name: '药研快报',
        content_type: '搜索',
        block_id: '',
        content_title: value,
        rank: ''
      })
    },
    async bannermaidian(event,uuid){
      await this.$api.aliyunHzMD({
        ...maidianP(event, null, null, null, null, uuid),
        fromfullname: this.fromfullname,
        funname: this.$route.fullPath
      })
    },
    generateSensorDic (item,index) {
      return JSON.stringify({
        pre_page_name: this.pre_page_name,
        block_name: '药研快报',
        content_type:'banner',
        block_id: item.uuid,
        content_title: item.name,
        rank: index
      })
    },
    lbtz(url, linktype, item) {
      if (!url) {
        console.log(url)
        return
      } else {
        this.bannermaidian('pv-drugNewspaper_banner',item.uuid)
        if (linktype == 0) {
            if(url.split('/#')[1]){
              this.$router.push(url.split('/#')[1])
            }else if(url.split('/hr')[1]){
              this.$router.push(url.split('/hr')[1])
            }
        } else {
          window.location.href = url
        }
      }
    },
     async scribejustify() {
      const res = await this.$api.scribejustify()
      if (typeof res === 'boolean' && !res) return
      this.zt = res
    },
    tz(id, type, row) {
      if (type == 24) {
        this.$router.push({ path: '/Livedetail/' + row.liveInfoDtos[0].videoStatus + '/' + id })
      } else if (this.dieaseId != undefined) {
        this.$router.push('/Documentdetail/' + id + '?dieaseId=' + this.dieaseId)
      } else if (this.$router.currentRoute.query.bosUserIds != undefined) {
        this.$router.push('/Documentdetail/' + id + '?bosUserIds=' + this.bosUserIds)
      } else {
        this.$router.push('/Documentdetail/' + id)
      }
    },
    changeSeo(id, type, row){
     if (type == 24) {
       return  '/Livedetail/' + row.liveInfoDtos[0].videoStatus + '/' + id 
      } else if (this.dieaseId != undefined) {
        return '/Documentdetail/' + id + '?dieaseId=' + this.dieaseId
      } else if (this.$router.currentRoute.query.bosUserIds != undefined) {
       return '/Documentdetail/' + id + '?bosUserIds=' + this.bosUserIds
      } else {
        return '/Documentdetail/' + id
      }
    },
    cs(value) {
      this.maidian('pv-drugNewspaper_search',value)
      this.collect = []
      this.pa = 1
      this.page = 1
      this.documentPage = 1
      this.finished = false
      this.sh = 0
      this.documentList(value)
    },
    async documentList(content) {
      console.log(this.docType,'123333')
      // console.log('hhh')
      let value = {}
      value.title = content
      value.page = this.page
      value.size = 8
      value.rareCaseUuid = this.$route.query.rareCaseUuid || undefined
      value.doctorUuid = this.$route.query.doctorUuid || undefined
      if (this.docType == 25) {
        value.docType = 25
      } else if(this.docType == 24) {
        value.docType = 24
      } else if(this.docType == 26) {
        value.docType = 26
      } else if (value.rareCaseUuid) {
        value.docType = 26
      }
      else {
        value.docTypes = [1, 25, 26]
      }
      
      value.uuid = this.$route.query.uuid || undefined
      value.docUuid = this.DocId || undefined
      value.medCategoryUuid = this.$route.query.medCategoryUuid || undefined
      value.medInstructionsUuid = this.$route.query.medInstructionsUuid || undefined
      if (this.$router.currentRoute.query.bosUserIds == null) {
        value.bosUserIds = undefined
      } else {
        value.bosUserIds = [Number(this.$router.currentRoute.query.bosUserIds)]
      }
      value.isHomePage = 1
      value.relatedDocUuid = this.DocId || undefined
      const res = await this.$api.documentList(value)
      if (!res || res.total == 0) {
        this.sh = 1
        this.textgd = ''
      } else {
        this.sh = 0
      }

      if (res == null) return
      this.nub = res.current

      this.loading = false
      if (!res || res.total == 0 || this.nub == res.pages) this.finished = true
      this.totalPage = Math.ceil(res.total/8)
      if(this.docType == 26 || this.docType == 25 || this.docType == 24 || this.docType == 1 || this.docType == '1,15') {
        if(this.page == 1) {
          this.collect = res.records
        } else {
          this.collect = [...this.collect, ...res.records]
        }
        // this.collect = res.records
      // } else if(this.docType == 1){
      //   if(this.page == 1) {
      //     this.collect = res.records
      //   } else {
      //     this.collect = [...this.collect, ...res.records]
      //   }
      // } else if(this.docType == '1,15') {
      //   if(this.page == 1) {
      //     this.collect = res.records
      //   } else {
      //     this.collect = [...this.collect, ...res.records]
      //   }
      } else {
        this.collect = res.records
      }
      
      
    },

    async getBannerList() {
      const res = await this.$api.getBannerList({
        type: 3
      })
      if (typeof res === 'boolean' && !res) return
      this.records = res.records
      this.records.forEach((v,i) => {
        v.bp = this.generateSensorDic(v,i)
      })
      console.log(this.records)
    },

    onLoad() {
      if (this.pa == 1) {
        this.pa++
        this.loading = false
        return
      }
      setTimeout(() => {
        this.page++
        if (this.refreshing) {
          this.refreshing = false
        }
        this.documentList(this.value)
        this.loading = false
        this.textgd = '没有更多了'
      }, 1000)
    }
  },
  mounted() {
    console.log(this.$route.params.docType)
    this.relatedDocId = this.$router.currentRoute.query.relatedDocId || undefined

    this.dieaseId = Number(this.$route.query.dieaseId) || undefined
    this.bosUserIds = [Number(this.$router.currentRoute.query.bosUserIds)]
    if (this.$store.state.user.identity === '') {
      this.show = true
    }

    this.documentList()
    // this.scribejustify()
    if (this.docType == 1) {
      document.title = '文章列表'
      this.share = {
        title: document.title,
        link: urlShare(),
        imgUrl: this.$store.state.app.qiniuHostUrl + 'login_logo.png'
      }
      this.$wxshare(this.share)
      localStorage.setItem('share', JSON.stringify(this.share))
      // this.$conShare()
    } else if (this.docType == 6) {
      document.title = '公开课列表'
      this.share = {
        title: document.title,
        link: urlShare(),
        imgUrl: this.$store.state.app.qiniuHostUrl + 'login_logo.png'
      }
      this.$wxshare(this.share)
      localStorage.setItem('share', JSON.stringify(this.share))
      // this.$conShare()
    } else if (this.docType == 24) {
      document.title = '罕见好课'
      this.share = {
        title: document.title,
        link: urlShare(),
        desc: '大咖深入讲解罕见病诊疗知识，进入罕见病新进展观看视频课程',
        imgUrl: this.$store.state.app.qiniuHostUrl + 'login_logo.png'
      }
      this.$wxshare(this.share)
      localStorage.setItem('share', JSON.stringify(this.share))
      // this.$conShare()
    } else if (this.docType == 25) {
      document.title = '药研快报'
      this.share = {
        title: document.title,
        link: urlShare(),
        desc: '全球罕见病药物获批及上市报道，进入罕见病新进展一键速查',
        imgUrl: this.$store.state.app.qiniuHostUrl + 'login_logo.png'
      }
      this.getBannerList()
      this.$wxshare(this.share)
      localStorage.setItem('share', JSON.stringify(this.share))
      // this.$conShare()
    } else {
      document.title = '资讯列表'
      this.share = {
        title: document.title,
        link: urlShare(),
        desc: '进入罕见病新进展，抢先一步掌握罕见病最新前沿资讯',
        imgUrl: this.$store.state.app.qiniuHostUrl + 'login_logo.png'
      }
      this.$wxshare(this.share)
      localStorage.setItem('share', JSON.stringify(this.share))
      // this.$conShare()
    }
  },
  // beforeRouterEnter:()
}
</script>

<style scoped>
.Lbigbox {
  box-sizing: border-box;
  /* background: #f4f4fa; */
}
.headbox {
  padding: 0px 20px 0px 20px;
  background: #fff;
}
.bodybox {
  padding: 6px 20px 0px 0px;
  margin-top: 0px;
  background: #fff;
}
.hrk {
  margin: 2px 0px;
  padding: 0px 20px;
  box-sizing: border-box;
}
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  height: 140px;
  text-align: center;
  /* background-color: #39a9ed; */
}
.my-swipe {
  border-radius: 6px;
}

.img {
  width: 100%;
  height: 100%;
  border-radius: 6px;
}
.pop_box {
  overflow: hidden;
  border-radius: 8px;
}
.pop {
  width: 300px;
  height: 210px;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;

  position: relative;
}
.pop_title {
  margin-top: 39px;
  font-size: 18px;
  color: #454556;
  font-weight: 800;
  text-align: center;
}
.pop_btn {
  width: 180px;
  margin: 0 auto;
  margin-top: 25px;
  display: flex;
  justify-content: space-between;
}
.pop_btn > div {
  width: 80px;
  height: 28px;
  border-radius: 20px;
  text-align: center;
  line-height: 28px;
}
.comm_btn {
  width: 182px;
  height: 32px;
  line-height: 32px;
  margin: 0 auto;
  margin-top: 35px;
  text-align: center;
  font-size: 15px;
  color: #fff;
  background: linear-gradient(180deg, #8051ed 0%, #7927cd 100%);
  border-radius: 16px;
}
.next {
  position: absolute;
  right: 10px;
  top: 10px;
  font-size: 13px;
  color: #cacad8;
}
.sho {
  background: #fff;
  padding-top: 48px;
}
.sho1 {
  margin: auto;
  text-align: center;
  color: #a27cca;
  font-size: 16px;
}
.sho2 {
  margin-top: 10px;
  text-align: center;
  color: #bbb3c3;
  font-size: 13px;
}
.van-search {
  padding: 0px;
  margin: 10px 0px;
  background: #f4f4fa;
  border-radius: 20px;
}
.van-search__content {
  background: none;
  width: 287px;
  box-sizing: border-box;
}
.van-search__action {
  /* width: 48px; */
  min-width: 48px;
  padding: 0 12px;
  height: 32px;
  background: #f3eeff;
  color: #7a1dd9;
  border-radius: 0px 20px 20px 0px;
  margin: auto;
  box-sizing: border-box;
}
.van-search__action > div {
  /* width: 26px; */
  white-space: nowrap;
  height: 32px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 32px;
}
.k8 {
  width: 100%;
  height: 8px;
  background: #f4f4fa;
}

.headbox /deep/ .van-icon {
  font-size: 24px;
}
.swipe {
  padding: 0px 20px;
  box-sizing: border-box;
  margin-bottom: 16px;
}
.kong {
  height: 50px;
}
</style>
